/* tslint:disable */
/* eslint-disable */
/**
 * NORA Api
 *  ## Headers  ### X-App-Version  Remember to include the `X-App-Version` header in every request. This will verify that the app version works with this API version. The API will return a `X-Minimum-App-Version` header as well including the minimum app version that is supported by this API. The contents of the header are is a JSON encoded DTO, `VersionHeaderDTO`. 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ApiResult } from '../models';
// @ts-ignore
import type { GetCurrentNotifications200Response } from '../models';
// @ts-ignore
import type { GetCurrentNotificationsActionParameter } from '../models';
// @ts-ignore
import type { GetNotification200Response } from '../models';
/**
 * UserNotificationsApi - axios parameter creator
 */
export const UserNotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary deleteAllNotifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/user/notification/delete-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary deleteNotification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('deleteNotification', 'notificationId', notificationId)
            const localVarPath = `/api/nora/nexus/user/notification/{notificationId}`
                .replace('{notificationId}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getCurrentNotifications
         * @param {GetCurrentNotificationsActionParameter} [action] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentNotifications: async (action?: GetCurrentNotificationsActionParameter, cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/nora/nexus/user/notification/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getNotification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('getNotification', 'notificationId', notificationId)
            const localVarPath = `/api/nora/nexus/user/notification/{notificationId}`
                .replace('{notificationId}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary getNotificationsByBbox
         * @param {number} minLongitude 
         * @param {number} minLatitude 
         * @param {number} maxLongitude 
         * @param {number} maxLatitude 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsByBbox: async (minLongitude: number, minLatitude: number, maxLongitude: number, maxLatitude: number, operationId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'minLongitude' is not null or undefined
            assertParamExists('getNotificationsByBbox', 'minLongitude', minLongitude)
            // verify required parameter 'minLatitude' is not null or undefined
            assertParamExists('getNotificationsByBbox', 'minLatitude', minLatitude)
            // verify required parameter 'maxLongitude' is not null or undefined
            assertParamExists('getNotificationsByBbox', 'maxLongitude', maxLongitude)
            // verify required parameter 'maxLatitude' is not null or undefined
            assertParamExists('getNotificationsByBbox', 'maxLatitude', maxLatitude)
            const localVarPath = `/api/nora/nexus/user/notification/bbox`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            if (minLongitude !== undefined) {
                localVarQueryParameter['minLongitude'] = minLongitude;
            }

            if (minLatitude !== undefined) {
                localVarQueryParameter['minLatitude'] = minLatitude;
            }

            if (maxLongitude !== undefined) {
                localVarQueryParameter['maxLongitude'] = maxLongitude;
            }

            if (maxLatitude !== undefined) {
                localVarQueryParameter['maxLatitude'] = maxLatitude;
            }

            if (operationId !== undefined) {
                localVarQueryParameter['operationId'] = operationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markNotificationAsRead
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsRead', 'notificationId', notificationId)
            const localVarPath = `/api/nora/nexus/user/notification/{notificationId}/mark-as-read`
                .replace('{notificationId}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary markNotificationAsUnread
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsUnread: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('markNotificationAsUnread', 'notificationId', notificationId)
            const localVarPath = `/api/nora/nexus/user/notification/{notificationId}/mark-as-unread`
                .replace('{notificationId}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication keycloak required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "keycloak", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserNotificationsApi - functional programming interface
 */
export const UserNotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserNotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary deleteAllNotifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAllNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAllNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.deleteAllNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary deleteNotification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.deleteNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getCurrentNotifications
         * @param {GetCurrentNotificationsActionParameter} [action] 
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentNotifications(action?: GetCurrentNotificationsActionParameter, cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentNotifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentNotifications(action, cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.getCurrentNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getNotification
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotification(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetNotification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotification(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.getNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary getNotificationsByBbox
         * @param {number} minLongitude 
         * @param {number} minLatitude 
         * @param {number} maxLongitude 
         * @param {number} maxLatitude 
         * @param {string} [operationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationsByBbox(minLongitude: number, minLatitude: number, maxLongitude: number, maxLatitude: number, operationId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCurrentNotifications200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationsByBbox(minLongitude, minLatitude, maxLongitude, maxLatitude, operationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.getNotificationsByBbox']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary markNotificationAsRead
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsRead(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsRead(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.markNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary markNotificationAsUnread
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markNotificationAsUnread(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markNotificationAsUnread(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserNotificationsApi.markNotificationAsUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserNotificationsApi - factory interface
 */
export const UserNotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserNotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary deleteAllNotifications
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAllNotifications(options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteAllNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary deleteNotification
         * @param {UserNotificationsApiDeleteNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteNotification(requestParameters: UserNotificationsApiDeleteNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.deleteNotification(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getCurrentNotifications
         * @param {UserNotificationsApiGetCurrentNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentNotifications(requestParameters: UserNotificationsApiGetCurrentNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentNotifications200Response> {
            return localVarFp.getCurrentNotifications(requestParameters.action, requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getNotification
         * @param {UserNotificationsApiGetNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(requestParameters: UserNotificationsApiGetNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetNotification200Response> {
            return localVarFp.getNotification(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary getNotificationsByBbox
         * @param {UserNotificationsApiGetNotificationsByBboxRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationsByBbox(requestParameters: UserNotificationsApiGetNotificationsByBboxRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetCurrentNotifications200Response> {
            return localVarFp.getNotificationsByBbox(requestParameters.minLongitude, requestParameters.minLatitude, requestParameters.maxLongitude, requestParameters.maxLatitude, requestParameters.operationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markNotificationAsRead
         * @param {UserNotificationsApiMarkNotificationAsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsRead(requestParameters: UserNotificationsApiMarkNotificationAsReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markNotificationAsRead(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary markNotificationAsUnread
         * @param {UserNotificationsApiMarkNotificationAsUnreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markNotificationAsUnread(requestParameters: UserNotificationsApiMarkNotificationAsUnreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<ApiResult> {
            return localVarFp.markNotificationAsUnread(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for deleteNotification operation in UserNotificationsApi.
 */
export interface UserNotificationsApiDeleteNotificationRequest {
    readonly notificationId: string
}

/**
 * Request parameters for getCurrentNotifications operation in UserNotificationsApi.
 */
export interface UserNotificationsApiGetCurrentNotificationsRequest {
    readonly action?: GetCurrentNotificationsActionParameter

    readonly cursor?: string

    readonly limit?: number
}

/**
 * Request parameters for getNotification operation in UserNotificationsApi.
 */
export interface UserNotificationsApiGetNotificationRequest {
    readonly notificationId: string
}

/**
 * Request parameters for getNotificationsByBbox operation in UserNotificationsApi.
 */
export interface UserNotificationsApiGetNotificationsByBboxRequest {
    readonly minLongitude: number

    readonly minLatitude: number

    readonly maxLongitude: number

    readonly maxLatitude: number

    readonly operationId?: string
}

/**
 * Request parameters for markNotificationAsRead operation in UserNotificationsApi.
 */
export interface UserNotificationsApiMarkNotificationAsReadRequest {
    readonly notificationId: string
}

/**
 * Request parameters for markNotificationAsUnread operation in UserNotificationsApi.
 */
export interface UserNotificationsApiMarkNotificationAsUnreadRequest {
    readonly notificationId: string
}

/**
 * UserNotificationsApi - object-oriented interface
 */
export class UserNotificationsApi extends BaseAPI {
    /**
     * 
     * @summary deleteAllNotifications
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteAllNotifications(options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).deleteAllNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary deleteNotification
     * @param {UserNotificationsApiDeleteNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public deleteNotification(requestParameters: UserNotificationsApiDeleteNotificationRequest, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).deleteNotification(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getCurrentNotifications
     * @param {UserNotificationsApiGetCurrentNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCurrentNotifications(requestParameters: UserNotificationsApiGetCurrentNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).getCurrentNotifications(requestParameters.action, requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getNotification
     * @param {UserNotificationsApiGetNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotification(requestParameters: UserNotificationsApiGetNotificationRequest, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).getNotification(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary getNotificationsByBbox
     * @param {UserNotificationsApiGetNotificationsByBboxRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getNotificationsByBbox(requestParameters: UserNotificationsApiGetNotificationsByBboxRequest, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).getNotificationsByBbox(requestParameters.minLongitude, requestParameters.minLatitude, requestParameters.maxLongitude, requestParameters.maxLatitude, requestParameters.operationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markNotificationAsRead
     * @param {UserNotificationsApiMarkNotificationAsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markNotificationAsRead(requestParameters: UserNotificationsApiMarkNotificationAsReadRequest, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).markNotificationAsRead(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary markNotificationAsUnread
     * @param {UserNotificationsApiMarkNotificationAsUnreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public markNotificationAsUnread(requestParameters: UserNotificationsApiMarkNotificationAsUnreadRequest, options?: RawAxiosRequestConfig) {
        return UserNotificationsApiFp(this.configuration).markNotificationAsUnread(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }
}

